import { Layout } from "antd";
import React from "react";

import SidebarMenu from "../sidebar/SidebarMenu";
import MainRoute from "../routes/MainRoute";
import MainHeader from "../header/MainHeader";
import MainFooter from "../footer/MainFooter";

const Main = () => {
  return (
    <div>
      <Layout
        style={{
          marginLeft: 200,
        }}
      >
        <MainHeader />
      </Layout>
      <Layout hasSider>
        <SidebarMenu />
        <MainRoute />
      </Layout>
      <Layout
        style={{
          marginLeft: 200,
        }}
      >
        <MainFooter />
      </Layout>
    </div>
  );
};

export default Main;
